module.exports = __webpack_public_path__ + "assets/img/ad5.66b00afc.svg";